import { createNgReactBridgeConstant } from '../../react-bridge'

// This is a legacy constant and should not be used.
// Use AttackStatus or SyslogAttackStatus instead.
export const ATTACK_STATUS_LABEL = {
  PROBED: 'Probed',
  PROBED_PERIMETER: 'Probed (P)',
  BLOCKED: 'Blocked',
  BLOCKED_PERIMETER: 'Blocked (P)',
  EXPLOITED: 'Exploited'
}

createNgReactBridgeConstant('ATTACK_STATUS_LABEL', ATTACK_STATUS_LABEL)
